import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import Button from '../../../../../component/ui/Button';
import { useState } from 'react';
import { toast } from 'react-toastify';
import Modal from '../../../../../component/modal/Modal';
import { createCreditNote, updateCreditNote } from '../../../../../services/sales_credit_note';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../../../../utils/controller';

const CreateCreditNoteHeader = ({
	error,
	setError,
	creditNote,
	creditNoteTable,
	totalAmount,
	salesReturnNumbers,
}) => {
	const navigate = useNavigate();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;
	const [loading, setLoading] = useState(false);
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isCreditNoteAutoSave, setIsCreditNoteAutoSave] = useState(false);

	const checkValidation = (status) => {
		let newError = { ...error };
		if (
			!creditNote.customer_id ||
			creditNote.customer_id === '' ||
			creditNote.customer_id === undefined
		) {
			newError.customer_id = 'Please select a valid customer from the list.';
		} else {
			delete newError.customer_id;
		}

		if (
			!creditNote.credit_note_number ||
			creditNote.credit_note_number === '' ||
			creditNote.credit_note_number === undefined
		) {
			newError.credit_note_number = 'Please enter credit note number in the field';
		} else {
			delete newError.credit_note_number;
		}

		if (
			!creditNote.date ||
			creditNote.date === '' ||
			creditNote.date === undefined ||
			(creditNote.date !== '' && newError.date)
		) {
			newError.date = newError.date ?? 'Please enter credit note date in the field';
		} else {
			delete newError.date;
		}

		if (
			!creditNote.credit_note_type ||
			creditNote.credit_note_type === '' ||
			creditNote.credit_note_type === undefined
		) {
			newError.credit_note_type = 'Please select a valid payment method from the list.';
		} else {
			delete newError.credit_note_type;
		}
		if (creditNote.credit_note_type === 1) {
			if (salesReturnNumbers.length === 0) {
				newError.sales_return_number = 'Please select a valid sales return number from the list.';
			} else {
				delete newError.return_number;
			}
		} else {
			delete newError.amount_paid;
		}
		if (creditNote.credit_note_type === 3) {
			if (
				!creditNote.amount_paid ||
				creditNote.amount_paid === '' ||
				creditNote.amount_paid === undefined ||
				(creditNote.amount_paid !== '' && newError.amount_paid)
			) {
				newError.amount_paid = 'Please enter amount in the field';
			} else {
				delete newError.amount_paid;
			}
		} else {
			delete newError.return_number;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	};

	const handleSubmitCreditNote = async (status, isCreditNote = false) => {
		const isErrorShow = checkValidation(status);
		if (isErrorShow) {
			toast.error('Please fill all mandatory fields before saving');
		} else {
			try {
				setLoading(true);
				const body = {
					customer_id: creditNote?.customer_id,
					credit_note_number: creditNote?.credit_note_number,
					date: creditNote?.date,
					credit_note_date: creditNote?.date,
					notes: creditNote?.notes,
					references: creditNote?.reference,
					credit_note_type: creditNote?.credit_note_type,
					credit_note_sales_return_ids:
						creditNote?.credit_note_type === 1
							? salesReturnNumbers.map((item) => {
									return item?.id;
								})
							: [],
					status: status,
					total_credit_amount:
						creditNote.credit_note_type !== 3 ? totalAmount().toFixed(2) : creditNote.amount_paid,
					credit_note_payment_receive_ids:
						creditNote?.credit_note_type === 2
							? creditNoteTable.map((item) => {
									return item?.id;
								})
							: [],
				};
				if (id) {
					var res = await updateCreditNote(id, body);
					if (res?.success) {
						toast.success('Credit Note updated Successfully');
						navigate(`/user/${suburl}/sales/credit-note`);
					} else {
						toast.error(res.message ?? 'something went wrong');
					}
				} else {
					const res = await createCreditNote(body);
					if (res?.success) {
						toast.success('Credit Note Created Successfully');
						setIsLocationBlocker(false);
						setIsCreditNoteAutoSave(false);
						setTimeout(() => {
							navigate(`/user/${suburl}/sales/credit-note`);
						}, 300);
					} else {
						toast.error(res.message ?? 'something went wrong');
					}
				}
			} catch (error) {
				toast.error(error.message ?? 'something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	useBlocker((tx) => {
		if (!id && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsCreditNoteAutoSave(true);
			return true;
		}
		return false;
	});

	return (
		<div
			className="product-pg-header add-product"
			style={{ position: 'sticky', top: 0, zIndex: 100 }}
		>
			<p>
				{id ? 'Update ' : 'Create New '}
				Credit Note
			</p>
			<div className="add-product-button">
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button="Save"
					loader={loading}
					disabled={
						loading || !hasPermission('sales.credit_note.create', user?.role?.role_permissions)
					}
					onClick={() => {
						setIsCreditNoteAutoSave(false);
						handleSubmitCreditNote(1);
					}}
				/>
				<Button
					type="button"
					className="mt-0 btn-danger add-pro"
					button=""
					close
					onClick={() => navigate(`/user/${suburl}/sales/credit-note`)}
				/>
			</div>

			{isCreditNoteAutoSave && (
				<Modal
					className="deleteVendorsModal"
					title="Credit Note Auto Save"
					isOpen={isCreditNoteAutoSave}
					onClose={() => {
						setIsCreditNoteAutoSave(false);
					}}
					cancelButton={() => {
						setIsCreditNoteAutoSave(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						You have unsaved changes. Do you want to continue without saving?
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Leave Without Saving"
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsLocationBlocker(false);
								setIsCreditNoteAutoSave(false);
								setTimeout(() => {
									navigate(isNextLocation.nextLocation?.pathname);
								}, 300);
							}}
						/>

						<Button
							type="button"
							button="Save and Continue"
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsCreditNoteAutoSave(false);
								handleSubmitCreditNote(1);
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};
export default CreateCreditNoteHeader;
